export const PRIMARY_COLOR = '#2261b6';